import IMask, { MaskedPatternOptions } from 'imask'

const defaultMobilePhoneMask = { mask: '+# 000 000 00-00', definitions: { '#': /[7-8]/ } }
export const formatMobilePhone = (mobilePhone?: string | number, rawMaskConfig?: MaskedPatternOptions) => {
  if (!mobilePhone) {
    return ''
  }
  const maskConfig = rawMaskConfig || defaultMobilePhoneMask
  const masked = IMask.createMask(maskConfig)

  masked.resolve(String(mobilePhone))

  return masked.value
}

export const parseMobilePhone = (mobilePhone?: string | number) => {
  if (!mobilePhone) {
    return ''
  }
  const masked = IMask.createMask({ mask: '00000000000' })

  masked.resolve(String(mobilePhone))

  return masked.value
}
